import { getSyntheticComplianceStatusName } from '@commenda/api';
import { Badge } from '@commenda/kakashi';
import { SyntheticComplianceStatus } from '@commenda/types/src/compliance-calendar/compliances/types';
import { NonTimezoneSensitiveDate } from '@commenda/utils';

const ComplianceStatusBadge = ({
  status,
  dueDate,
}: {
  status: SyntheticComplianceStatus;
  dueDate: string;
}) => {
  let variant:
    | 'success'
    | 'error'
    | 'default'
    | 'warning'
    | 'accent-blue'
    | 'orange' = 'warning';

  if (status === SyntheticComplianceStatus.FILED) variant = 'success';
  else if (status === SyntheticComplianceStatus.DUE_SOON) variant = 'error';
  else if (status === SyntheticComplianceStatus.UNDER_FILING)
    variant = 'warning';
  else if (status === SyntheticComplianceStatus.COMPLETED) variant = 'success';
  else if (status === SyntheticComplianceStatus.EXTENDED) variant = 'orange';

  const isOverDue =
    status &&
    NonTimezoneSensitiveDate.fromISO8601String(dueDate).lte(
      NonTimezoneSensitiveDate.fromNativeDate(new Date())
    );

  // EXTENDED is sticky — it keeps its orange pill even past the new dueDate. Only items
  // that are still in the "to file" lifecycle should flip to Overdue based on the date.
  if (
    isOverDue &&
    status !== SyntheticComplianceStatus.COMPLETED &&
    status !== SyntheticComplianceStatus.FILED &&
    status !== SyntheticComplianceStatus.EXTENDED
  ) {
    return (
      <Badge variant="error" size="sm">
        Overdue
      </Badge>
    );
  }

  return (
    <Badge size="sm" variant={variant}>
      {status === SyntheticComplianceStatus.NOT_FILED
        ? 'Upcoming'
        : getSyntheticComplianceStatusName(status)}
    </Badge>
  );
};

export default ComplianceStatusBadge;
